"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpDependencies = void 0;
var _dependenciesHelpClassGenerated = require("./dependenciesHelpClass.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var helpDependencies = exports.helpDependencies = {
  HelpDependencies: _dependenciesHelpClassGenerated.HelpDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createHelp: _factoriesAny.createHelp
};